module.exports = __webpack_public_path__ + "img/two_3.94ff2c68.png";